import type { LiveInputs, LiveInputsPostLinkInterface } from '../../types'
import type Tooltip from '@app/setup/tooltip/uikit-tooltip'

class LiveInputsNewRowLink implements LiveInputsPostLinkInterface {
  private liveInputs: LiveInputs
  private inputFilter: string = "[data-behaviour~='live-inputs-new-row-link']"

  constructor(liveInputs: LiveInputs) {
    this.liveInputs = liveInputs
    this.initializeListeners()
  }

  private initializeListeners(): void {
    this.liveInputs.on('click', this.inputFilter, this.handleClick)
  }

  // HandleClick is auto-bound as a stable reference
  handleClick = (event: Event): void => {
    event.preventDefault()

    const target = event.target as HTMLElement

    if (!target) {
      return
    }

    const tooltip = $(target).data('tooltip-instance') as Tooltip
    if (tooltip) {
      tooltip.dispose()
    }

    const namespace = target
      .closest<HTMLElement>(this.inputFilter)
      ?.dataset.name?.split('.')[0]

    this.liveInputs.setTabDirection(0)
    this.liveInputs.update($(target), {
      renderTooltips: false,
      submit: true,
      new_row_button: true,
      // Use the server's key, not the button's: for an empty collection the button says _1, but the server also saves _2.
      successCallback: (data: { changedTextPropertyKey?: string }) =>
        this.focusNewRow(namespace, data.changedTextPropertyKey),
    })
  }

  private focusNewRow(namespace?: string, key?: string): void {
    if (!namespace || !key) {
      return
    }

    this.liveInputs.$container
      .find(`[data-name^='${namespace}.${key}.']`)
      .filter('input:visible,textarea:visible,select:visible')
      .first()
      .trigger('focus')
  }

  teardown(): void {
    this.liveInputs.off('click', this.inputFilter, this.handleClick)
  }
}

export default LiveInputsNewRowLink
